import { useRef, useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
} from '@mui/material';
import { capitalizeString, splitName, stringToColor } from 'utils/stringHelper';
import useAuth from '../../hooks/useAuth';
import UserIcon from '../../icons/User';
import { UserProfilesNames } from 'src/types/claims';

const AccountPopover: FC = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLogout = () => {
    handleClose();
    logout();
    navigate('/');
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Avatar
          sx={{
            height: 32,
            width: 32,
            fontSize: '1rem',
            bgcolor: stringToColor(capitalizeString(user?.name ?? '')),
          }}
        >
          {splitName(capitalizeString(user?.name ?? ''))}
        </Avatar>
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        anchorReference={undefined}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            color="textPrimary"
            variant="subtitle2"
          >
            {user?.name}
          </Typography>
          <Typography
            color="textSecondary"
            variant="subtitle2"
          >
            {user?.profileName}
          </Typography>
        </Box>
        <Divider />
        {user?.profileName !== UserProfilesNames.Inspector && (
          <Box sx={{ mt: 2 }}>
            <MenuItem
              component={RouterLink}
              to="/perfilUsuario"
              onClick={() => handleClose()}
            >
              <ListItemIcon>
                <UserIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                  >
                    Perfil
                  </Typography>
                }
              />
            </MenuItem>
          </Box>
        )}
        <Box sx={{ p: 2 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            Cerrar Sesión
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default AccountPopover;
